module.exports = __webpack_public_path__ + "static/media/space_jam.6bf7c24a.png";